
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1604125417446",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "58858",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M598.4 0h-169.6c-25.6 0-44.8 19.2-44.8 41.6 0 22.4 19.2 41.6 41.6 41.6h169.6c22.4 0 41.6-19.2 41.6-41.6 3.2-22.4-16-41.6-38.4-41.6zM256 0H137.6C60.8 0 0 60.8 0 137.6V256c0 22.4 19.2 41.6 41.6 41.6S86.4 278.4 86.4 256V137.6c0-28.8 22.4-51.2 51.2-51.2H256c22.4 0 41.6-19.2 41.6-41.6C297.6 19.2 278.4 0 256 0zM41.6 640c22.4 0 41.6-19.2 41.6-41.6v-169.6c0-22.4-19.2-41.6-41.6-41.6S0 403.2 0 425.6v169.6c0 25.6 19.2 44.8 41.6 44.8zM256 937.6H137.6c-28.8 0-51.2-22.4-51.2-51.2V768c0-22.4-19.2-41.6-41.6-41.6S0 745.6 0 768v118.4C0 963.2 60.8 1024 137.6 1024H256c22.4 0 41.6-19.2 41.6-41.6 0-25.6-19.2-44.8-41.6-44.8zM598.4 937.6h-169.6c-22.4 0-41.6 19.2-41.6 41.6 0 22.4 19.2 41.6 41.6 41.6h169.6c22.4 0 41.6-19.2 41.6-41.6 0-22.4-19.2-41.6-41.6-41.6zM982.4 726.4c-22.4 0-41.6 19.2-41.6 41.6v118.4c0 28.8-22.4 51.2-51.2 51.2H768c-22.4 0-41.6 19.2-41.6 41.6 0 22.4 19.2 41.6 41.6 41.6h118.4c73.6 0 137.6-60.8 137.6-137.6V768c0-22.4-19.2-41.6-41.6-41.6zM982.4 384c-22.4 0-41.6 19.2-41.6 41.6v169.6c0 22.4 19.2 41.6 41.6 41.6 22.4 0 41.6-19.2 41.6-41.6v-169.6c0-22.4-19.2-41.6-41.6-41.6zM886.4 0H768c-22.4 0-41.6 19.2-41.6 41.6 0 22.4 19.2 41.6 41.6 41.6h118.4c28.8 0 51.2 22.4 51.2 51.2V256c0 22.4 19.2 41.6 41.6 41.6 25.6 0 44.8-19.2 44.8-41.6V137.6C1024 60.8 963.2 0 886.4 0z",
        "p-id": "58859"
      }
    }
  ]
})
    }
  